import { BaseType } from '../base/base-type';

export class DesignatedUnitType extends BaseType {}
